import {
  type ConstraintType,
  type Description,
  type IConstraintParams,
  type IValidationConfigResponse,
  type TValidationConfig,
} from '../types/configs';
import { FieldPrefix } from '../constants/fieldPrefixes';

const fieldPrefixByDescription = {
  lpco: FieldPrefix.lpco,
  item: FieldPrefix.item,
  beneficiaries: FieldPrefix.beneficiary,
  'request-fees': FieldPrefix.fee,
  attachedDocuments: FieldPrefix.attachedDocument,
  packages: FieldPrefix.packages,
  treatments: FieldPrefix.treatments,
  'request-additionalfields': FieldPrefix.additionalFields, //todo
} as Record<Description, FieldPrefix>;

function convertValidationConfig(validationConfigResponse: IValidationConfigResponse) {
  const config = {} as TValidationConfig;

  validationConfigResponse.rules.forEach(({ description, fields }) => {
    Object.entries(fields ?? {}).forEach(([key, value]) => {
      if (description in fieldPrefixByDescription) {
        const fieldName = fieldPrefixByDescription[description] + key;
        config[fieldName] = value.constraints.reduce((acc, { type, params }) => {
          acc[type] = params;

          return acc;
        }, {} as Record<ConstraintType, IConstraintParams>);
      }
    });
  });

  return config;
}

export default convertValidationConfig;
